import { __extends } from 'tslib';
import classNames from 'classnames';
import * as React from 'react';
import { thousands } from '../../formatting.js';
import { t } from '../../localization.js';
import styles from './Currency.module.scss.js';

var Currency = (function (_super) {
    __extends(Currency, _super);
    function Currency() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.getAmount = function () {
            return ("" + _this.props.amount)
                .split('/')
                .map(function (part) { return thousands(part); })
                .join('/');
        };
        return _this;
    }
    Currency.prototype.render = function () {
        var _a;
        if (!Currency.types[this.props.type]) {
            return null;
        }
        var style = {};
        if (this.props.color) {
            style.color = this.props.color;
        }
        return (React.createElement("div", { style: style, className: classNames(styles.currency, styles[this.props.type], (_a = {},
                _a[styles.isBold] = !!this.props.isBold,
                _a[styles.withMargin] = !!this.props.withMargin,
                _a[styles.isFlat] = !!this.props.isFlat,
                _a), this.props.className) }, !!this.props.onlyIcon ? null : this.getAmount()));
    };
    Currency.metricIconName = {
        exp: 'silver-star',
        damage: 'damage',
        ribbons_count: 'ribbon',
    };
    Currency.order = {
        steel: 4,
        coal: 3,
        dublon: 2,
        gold: 2,
        oil: 1,
    };
    Currency.names = {
        exp: 'exp',
        'free-exp': 'free-exp',
        gold: t('Дублоны'),
        credits: 'credits',
        dublon: t('Дублоны'),
        oil: t('Нефть'),
        coal: t('Уголь'),
        steel: t('Сталь'),
        'silver-star': 'silver-star',
        'gold-star': 'gold-star',
        ribbon: t('Ленты'),
        damage: t('Урон'),
        eventum: 'eventum',
        'clan-tag': 'clan-tag',
        'clan-rank': 'clan-rank',
        'elite-xp': 'elite-xp',
    };
    Currency.types = {
        exp: 'exp',
        'free-exp': 'free-exp',
        gold: 'dublon',
        credits: 'credits',
        dublon: 'dublon',
        oil: 'oil',
        coal: 'coal',
        steel: 'steel',
        'silver-star': 'silver-star',
        'gold-star': 'gold-star',
        ribbon: 'ribbon',
        damage: 'damage',
        'cwars-star': 'cwars-star',
        eventum: 'eventum',
        'clan-tag': 'clan-tag',
        'clan-rank': 'clan-rank',
        'elite-xp': 'elite-xp',
    };
    return Currency;
}(React.PureComponent));

export { Currency as default };
//# sourceMappingURL=Currency.js.map
